export default "__VITE_ASSET__B_je88cI__"